<template>
  <div class="form-submit">
        <p v-html="withDisclaimerText" v-if="disclaimer"></p>
        <div class="form-submit--wrap">
            <button type="submit"
                    class="form-submit--btn btn btn__medium btn__neutral"
                    :class="buttonClasses"
                    ref="submit"
                    :disabled="isPending ? true : null"
                    @click.prevent.stop="onSubmit">
                    <cmp-dot-loader class="form-submit--dot-loader"
                            :is-active="isPending">
                    </cmp-dot-loader>
                    <span class="form-submit--btn-content btn--wrap">
                        <span class="btn--text" v-text="label"></span>
                    </span>
            </button>
        </div>

        <div class="form-submit--general-errors" v-if="generalErrors.length">
            <span v-for="(generalError, generalErrorIdx) in generalErrors"
                    class="general-error form-submit--general-error"
                    v-text="generalError">
            </span>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import isMountedMixin from 'vue/mixins/is-mounted';


    export default {
        mixins: [
            bemMixin('form-submit'),
            isMountedMixin,
        ],
        props: {
            disclaimer: {
                type: String,
                default: '',
            },
            label: {
                type: String,
                required: true,
            },
            isSubmitting: Boolean,
            sitekey: {
                type: String,
                required: true,
            },
            generalErrors: {
                type: Array,
            },
        },
        data() {
            return {
                globals,
                grecaptchaIsInitted: false,
                grecaptchaWidgetId: null,
                isSubmitTriggered: false,
            };
        },
        computed: {
            withDisclaimerText() {
                if (!this.disclaimer) {
                    return '';
                }
                // I'm removing all tags and use the text as a description for the buttons so that the text will be read by the screen readers.
                const label = this.disclaimer.replaceAll(/<(.*?)>/gm, '').replaceAll(/<\/(.*?)>/gm, '');
                // I'm adding to the first Link the description as a title.
                const text = this.disclaimer.replace('<a', `<a title="${ label }"`);
                return text;
            },
            grecaptchaIsReady() {
                return this.isMounted && this.globals.state.googleRecaptchaLoaded;
            },
            buttonClasses() {
                return [
                    this.bemAdd(this.isPending ? 'is-submitting' : '', 'btn'),
                ];
            },
            isPending() {
                return this.isSubmitTriggered || this.isSubmitting;
            },
        },
        methods: {
            onSubmit() {
                if (!this.grecaptchaIsReady) {
                    return;
                }

                this.isSubmitTriggered = true;

                window.grecaptcha.reset(this.grecaptchaWidgetId);
                window.grecaptcha.execute(this.grecaptchaWidgetId);

                setTimeout(() => {
                    this.isSubmitTriggered = false;
                }, 1000);
            },
            onGrecaptchaSuccess() {
                this.$emit('recaptcha-submit');
            },
        },
        watch: {
            grecaptchaIsReady: {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    this.grecaptchaWidgetId = window.grecaptcha.render(this.$refs.submit, {
                        badge: 'inline',
                        sitekey: this.sitekey,
                        callback: this.onGrecaptchaSuccess,
                    });

                    this.grecaptchaIsInitted = true;
                },
                immediate: true,
            },
            isSubmitting: {
                handler(val) {
                    if (val) {
                        return;
                    }

                    this.isSubmitTriggered = false;
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?058f2846